import {GameEvent, isPlayerAction, Scene, SceneMutator} from '@glark-newco/game-library';
import {isDisplayPlaySceneEvent, isReviewStatsEvent} from '../SupplyChainPayloadTypes';

export const SupplyChainSceneMutator: SceneMutator = (existing: Scene, event: GameEvent)=> {
    if (isPlayerAction(event) && isDisplayPlaySceneEvent(event)) {
        return 'PLAY';
    }
    if (isPlayerAction(event) && isReviewStatsEvent(event)) {
        return 'REVIEW';
    }
    return existing;
};
